import {
  WIDGET_MODULE_SCRIPT_SRC,
  WIDGET_PARTNER_SCRIPT_SRC,
} from '../constants'

export const getEmbedCodeSnippet = (
  integrationId: string,
  partnerId: string
) => `<script
      type="text/javascript"
      src="${WIDGET_PARTNER_SCRIPT_SRC}"
    ></script>
    <script
      type="module"
      src="${WIDGET_MODULE_SCRIPT_SRC}"
    ></script>
    <labra-widget
      integration-id=${integrationId} partner-id=${partnerId}
    ></labra-widget>`
